import type { CTRL_SCHEMA } from "@repo/sdk/types";
import { useHttp, type HttpConfiguration } from "@repo/utils/hooks";
import { useCtrlClient } from "../contexts/CtrlApiProvider";

/**
 * A permission group, always scoped to a single tenant.
 *
 * Backed by the FGA `group` type (`pkg/fga/model.fga` in `off-board/ctrl`)
 * which declares exactly one parent relation `tenant: [tenant]`, mirrored
 * in `raw_groups (tenant_id UUID NOT NULL REFERENCES raw_tenants(id))`.
 */
export type TenantGroup = CTRL_SCHEMA["DbGroup"];

/** @deprecated Use `TenantGroup` instead. */
export type Group = TenantGroup;

export function useTenantGroups(
  tenantId: string | undefined,
  config?: HttpConfiguration,
) {
  const client = useCtrlClient();

  return useHttp<TenantGroup[]>(
    client.token && tenantId ? `tenants/${tenantId}/groups` : null,
    async () => {
      return await client.getTenantGroups(tenantId!);
    },
    config,
  );
}
